module.exports = __webpack_public_path__ + "media/img/help_center/Student_Institution_Directory_04-b3637cf86d1314651850ac919d2555d4.jpg";